import IRequest from "../../IRequest";

export interface IFluxo {
    reqFuncoes: IRequest<TFluxoProcesso>,
    dataFuncoes: TFluxoProcesso[]
}

export type TFluxoProcesso = {
    id: number;
    nome: string;
}

export const defValueFluxo = {
    id: 0,
    nome: '',
}